var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 489,
    height: 409,
    viewBox: "0 0 489 409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .shp0{fill:#2f2e41}.shp1{fill:#3f3d56}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M299.06 367.18H62.27v-1.7h235.09v-82.62H82.18l-10.45-21.78 1.53-.73 9.99 20.81h215.81v86.02z",
    className: "shp0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M93.79 408.92c-9.89 0-17.89-8-17.89-17.89s8-17.88 17.89-17.88 17.89 7.99 17.89 17.88c0 9.89-8 17.89-17.89 17.89zM270.1 408.92c-9.89 0-17.89-8-17.89-17.89s8-17.88 17.89-17.88 17.89 7.99 17.89 17.88c0 9.89-8 17.89-17.89 17.89zM477.93 22.23c-6.13 0-11.08-4.95-11.08-11.08 0-6.12 4.95-11.07 11.08-11.07C484.05.08 489 5.03 489 11.15c0 6.13-4.95 11.08-11.07 11.08z",
    className: "shp1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    d: "M324.39 254.75H58.24L.65 66.52h383.04l-.35 1.1-58.95 187.13zm-264.89-1.7h263.64l58.23-184.83H2.95L59.5 253.05z",
    className: "shp0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "#f2f2f2",
    d: "M303.61 244.96H69.84L19.26 78.01H355.7l-.31.99-51.78 165.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M388.46 49.7l-1.64-.44 11.24-42.37h65.39V8.6h-64.08l-10.91 41.1zM19.26 123.58h345.29v1.71H19.26v-1.71zM38.46 186.34h306.32v1.71H38.46v-1.71z",
    className: "shp0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M191.31 67.37h1.71V253.9h-1.71V67.37zM257.06 253.84l12.23-186.53 1.7.12-12.23 186.52-1.7-.11zM113.38 67.42l1.7-.11 12.16 186.54-1.7.11-12.16-186.54z",
    className: "shp0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.9f1a28a70289139b1b8eba6d450064db.svg";
export { ForwardRef as ReactComponent };